import { render, staticRenderFns } from "./MinimizeStep.vue?vue&type=template&id=55a1b5c7&scoped=true&"
import script from "./MinimizeStep.vue?vue&type=script&lang=js&"
export * from "./MinimizeStep.vue?vue&type=script&lang=js&"
import style0 from "./MinimizeStep.vue?vue&type=style&index=0&id=55a1b5c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1b5c7",
  null
  
)

export default component.exports